import { IItemCache } from '../IItemCacheObserver';
import { parentItemFacet } from '../../facets/SetFacets';

/**
 * @beta
 */
export function getItemKey(itemCache: IItemCache, props: {
  itemKey: string | undefined;
}): string | undefined {
  let itemKey = props.itemKey;

  if (itemKey) {
    const parentItem = itemCache.demandItemFacet(parentItemFacet, itemKey);

    if (parentItem) {
      itemKey = parentItem.itemKey;
    }
  }

  return itemKey;
}
